import { LeaveInformationContentHeader } from "./LeaveInformationContentHeader";
import { LeaveInformationContentForm } from "./LeaveInformationContentForm";
import { JSX } from "react";

export const LeaveInformationContent = (): JSX.Element => {
    return (
        <div className={"p-leave-information__content"}>
            <LeaveInformationContentHeader />
            <LeaveInformationContentForm />
        </div>
    );
};
